import React, { Component } from 'react';
import { connect } from 'react-redux';
import { RegularPage } from '../Templates';
import { Paper, Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { UserActions, LeadActions } from '../../actions';
import { Lead } from './';

const styles = (them) => ({
    tablePapper: {
        width: '100%',
        overflowX: 'auto'
    }
});

class LeadsPage extends Component {
    constructor(props) {
        super(props);

        this.state = {}

        this.usersDatalist = this.usersDatalist.bind(this)
    }

    componentDidMount() {
        const {dispatch} = this.props;
        dispatch(LeadActions.getAllLeads());
        dispatch(UserActions.getAllUsers());
    }

    usersDatalist() {
        const {users} = this.props;
        const usersData = {};
        
        if(users && users.list) {
            users.list.forEach((item) => {
                usersData[item._id] = item;
            });
        }

        return usersData
    }

    render() {
        const {leads, classes} = this.props;
        const allLeads = (leads && leads.list) || [];
        const usersData = this.usersDatalist();
        const renderLeads = allLeads.map((item) => <Lead data={item} userData={usersData[item.userID]} key={item._id}/>).reverse()

        return (
            <RegularPage>
                <Paper className={classes.tablePapper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Edit</TableCell>
                                <TableCell>Created&nbsp;At</TableCell>
                                <TableCell>User</TableCell>
                                <TableCell>Interested</TableCell>
                                <TableCell>Contact</TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell>Phone</TableCell>
                                <TableCell>Area</TableCell>
                                <TableCell>Date</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {renderLeads}
                        </TableBody>
                    </Table>
                </Paper>
            </RegularPage>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        users: state.userReducer,
        leads: state.leadReducer
    }
}

const LeadsPageWithRedux = withStyles(styles)(connect(mapStateToProps)(LeadsPage));

export {LeadsPageWithRedux as LeadsPage};


// WEBPACK FOOTER //
// ./src/components/LeadsPage/LeadsPage.jsx